const permissions = [
    {
        id: 1,
        title: 'مدیریت',
        rules: [
            'سرپرست',
            'مدیر',
            'کاربران',
        ],
        createdAt: '14 فروردین 1401، 8:43 ب.ظ',
    },
    {
        id: 2,
        title: 'مدیریت پرداخت ها و نقش',
        rules: [
            'کاربر محدود',
            'پشتیبانی',
        ],
        createdAt: '16 اردیبهشت 1401، 5:20 ب.ظ',
    },
    {
        id: 3,
        title: 'افزودن و حذف کاربران',
        rules: [
            'سرپرست',
            'مدیر',
            'پشتیبانی',
        ],
        createdAt: '14 خرداد 1401، 10:20 ق.ظ',
    },
    {
        id: 4,
        title: 'برنامه ریزی پروژه',
        rules: [
            'سرپرست',
            'کاربر محدود',
            'مدیر',
        ],
        createdAt: '14 تیر 1401، 12:10 ب.ظ',
    },
    {
        id: 5,
        title: 'مدیریت ایمیل ها',
        rules: [
            'سرپرست',
            'پشتیبانی',
        ],
        createdAt: '23 مرداد 1401، 2:00 ب.ظ',
    },
    {
        id: 6,
        title: 'مدیریت مشتریان',
        rules: [
            'پشتیبانی',
            'کاربران',
        ],
        createdAt: '15 فروردین 1401، 11:30 ق.ظ',
    },
]

export default permissions